export const serializedMessages = (messages) =>
  messages.map((message) => {
    return { role: message.role, content: message.content };
  });
